import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserDetail } from "utils/getUserDetailsHelper";
import config from "configs/config";

const decodeCrmToken = (token) => {
  try {
    const base64url = token.split(".")[1];
    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "==".slice(0, (4 - (base64.length % 4)) % 4);
    const payload = JSON.parse(atob(padded));
    console.log("[ProtectedRoute] JWT payload:", payload);
    return payload._id || payload.id || payload.userId || payload.sub || payload.aud || null;
  } catch (err) {
    console.error("[ProtectedRoute] JWT decode error:", err);
    return null;
  }
};

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [authState, setAuthState] = useState(getUserDetail("_id") ? "authed" : "checking");

  useEffect(() => {
    if (authState !== "checking") return;

    const tryAutoLogin = async () => {
      const params = new URLSearchParams(window.location.search);
      const encoded = params.get("crmState");
      console.log("[ProtectedRoute] crmState encoded:", encoded);

      if (encoded) {
        try {
          const crmState = JSON.parse(atob(encoded));
          console.log("[ProtectedRoute] crmState decoded:", crmState);
          const crmToken = crmState.token;
          console.log("[ProtectedRoute] crmToken:", crmToken ? "present" : "MISSING");

          if (crmToken) {
            const userId = decodeCrmToken(crmToken);
            console.log("[ProtectedRoute] userId from JWT:", userId);
            if (userId) {
              const res = await fetch(`${config.baseUrl}/api/v1/role/permissions/${userId}`, {
                headers: {
                  Authorization: `Bearer ${crmToken}`,
                  ProjectDetail: "Vision",
                },
              });
              const data = await res.json();
              console.log("[ProtectedRoute] permissions response:", data);
              if (data?.role) {
                const userData = { _id: userId, token: crmToken, role: data.role };
                localStorage.setItem("userData", JSON.stringify(userData));
                sessionStorage.setItem("userData", JSON.stringify(userData));
                setAuthState("authed");
                return;
              }
            }
          }
        } catch (err) {
          console.error("[ProtectedRoute] auto-login error:", err);
        }
      }

      console.log("[ProtectedRoute] falling back to login");
      navigate("/login");
      setAuthState("unauthed");
    };

    tryAutoLogin();
  }, [authState, navigate]);

  if (authState === "authed") return children;
  return null;
};

export default ProtectedRoute;
